<div fxFlex="100" fxLayout="row wrap" *transloco="let translate">
  <eg-card-table
    [columns]="columns"
    [dataSource]="filters"
    (sortDirectionChange)="sortChange($event)"
    [showAction]="false"
    class="table py-10"
    fxFlex="100"
  >
    <ng-template #emptyTableTemplate>
      <rmb-table-not-found></rmb-table-not-found>
    </ng-template>
  </eg-card-table>
</div>
